import { createStyles, Group, Skeleton, Stack } from '@mantine/core';

const useStyles = createStyles((theme) => ({
	skeletonIcon: {
		width: 28,
		height: 28,
		borderRadius: theme.radius.sm,
		flexShrink: 0,
	},
}));

export function LoadingState() {
	const { classes, theme } = useStyles();
	return (
		<Stack spacing="md">
			<Group spacing="2xs">
				<Skeleton className={classes.skeletonIcon} />
				<Stack spacing="2xs">
					<Skeleton w={340} h={theme.spacing.xs} />
					<Skeleton w={324} h={theme.spacing.xs} />
				</Stack>
			</Group>
			<Stack spacing="sm" py="xs">
				<Skeleton w="100%" h={theme.spacing.xs} />
				<Skeleton w="100%" h={theme.spacing.xs} />
				<Skeleton w="100%" h={theme.spacing.xs} />
				<Skeleton w="100%" h={theme.spacing.xs} />
				<Skeleton w={368} h={theme.spacing.xs} />
			</Stack>
		</Stack>
	);
}
